import { formatCurrency as sharedFormatCurrency, getCurrencySymbol as sharedGetCurrencySymbol } from '../../helpers/currency';

export function formatCurrency(value, currency = 'BRL') {
    const num = parseFloat(value) || 0;
    if (num !== 0 && Math.abs(num * 100 - Math.round(num * 100)) > 0.0001) {
        const safeCurrency = currency || 'BRL';
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: safeCurrency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 4,
        }).format(num);
    }
    return sharedFormatCurrency(value, currency);
}

export function getCurrencySymbol(currency = 'BRL') {
    return sharedGetCurrencySymbol(currency);
}
